import script from "./DesktopMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&setup=true&lang=js"

import "./DesktopMenu.vue?vue&type=style&index=0&id=714e4f35&lang=css"

const __exports__ = script;

export default __exports__